import React from 'react';
import { Card, Button, Alert } from 'react-bootstrap';
import { Copy, Check, ExternalLink } from 'lucide-react';
import { useClipboard } from '../../hooks/useClipboard';
import { getWebhookUrl } from '../../config';

/**
 * Webhook Info Card Component
 * Displays webhook URL with copy-to-clipboard functionality
 */
const WebhookInfoCard: React.FC = () => {
    const { copied, copyToClipboard } = useClipboard();
    const webhookUrl = getWebhookUrl();

    const handleCopy = () => {
        copyToClipboard(webhookUrl);
    };

    return (
        <Alert variant="info" className="mt-4">
            <h6 className="fw-bold mb-2">
                <ExternalLink size={18} className="me-2" />
                URL do Webhook
            </h6>
            
            <Card className="bg-white border-0 shadow-sm">
                <Card.Body className="p-3">
                    <div className="d-flex align-items-center justify-content-between">
                        <code 
                            className="flex-grow-1 me-3 text-break" 
                            style={{ 
                                fontSize: '0.9rem',
                                fontFamily: 'monospace'
                            }}
                        >
                            {webhookUrl}
                        </code>
                        <Button
                            variant={copied ? "success" : "outline-primary"}
                            size="sm"
                            onClick={handleCopy}
                            className="d-flex align-items-center gap-2 flex-shrink-0"
                        >
                            {copied ? (
                                <>
                                    <Check size={16} /> Copiado
                                </>
                            ) : (
                                <>
                                    <Copy size={16} /> Copiar
                                </>
                            )}
                        </Button>
                    </div>
                </Card.Body>
            </Card>
            
            <small className="text-muted d-block mt-2">
                Configure esta URL no painel do Meta Developers em <strong>WhatsApp &gt; Configuração &gt; Webhooks</strong>
            </small>
        </Alert>
    );
};

export default WebhookInfoCard;
